module.exports = __webpack_public_path__ + "static/media/rpn.ed5bc02b.png";